/* eslint-disable */

import * as _ from 'lodash';
/**
 * InstanceLink class.
 *
 * @constructor
 */
function InstanceLink(props) {

  var that = this;

  if (typeof props !== "undefined") {
    _.forEach(props, function(value, prop) {
      switch (prop) {
        case "recordChangeDateTime":
        case "recordCreateDateTime":
        case "recordSyncDateTime":
        case "deleted": {
          // ignore these
          break;
        }
        case "instanceLinkOrgUUID": {
          that[prop] = value;
          that.orgUUID = value;
          break;
        }
        case "instanceLinkOrgGroupUUID": {
          that[prop] = value;
          that.orgGroupUUID = value;
          break;
        }
        case "instanceLinkOrgLocationUUID": {
          that[prop] = value;
          that.orgLocationUUID = value;
          break;
        }
        case "instanceLinkOrgUnitUUID": {
          that[prop] = value;
          that.orgUnitUUID = value;
          break;
        }
        default:
          that[prop] = value;
          break;
      }
    });
  }
}

export default InstanceLink;


// WEBPACK FOOTER //
// ./src/qoc-sdk/models/instance/InstanceLink.js